export const menuItems = [
  {
    name: "#about-us",
    label: "About Us",
    isExternal: false,
  },
  {
    name: "#our-services",
    label: "Our Services",
    isExternal: false,
  },
  
];
